<template>
  <div>
    <div class="van-row--flex van-clearfix inputTop">
<!--      <img src="@/assets/img/arrow.png" alt="" class="arrow" @click="goBack">-->
      <div class="flexOne s_input">
        <van-field v-model="searchWord" maxlength="20"  class="searchInput" placeholder="请输入关键词" @input="searchInput" @focus="inputFocus"/>
<!--        <img src="@/assets/img/close.png" alt="" class="close" @click="closeWord">-->
      </div>
<!--      <div class="car">-->
<!--        <img src="@/assets/img/search_icon_1.png" alt="" class="search_icon">-->
<!--      </div>-->
    </div>
    
    <div class="commonPadding">
      <div class="linePo"></div>
      <div v-if="goodsList.length > 0" class="van-clearfix">
        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
          <van-list v-model="isUpLoading" :finished="upFinished" :immediate-check="false"
                    :offset="offset" finished-text="" @load="onLoadList">
            <ul class="newsUl van-clearfix" v-if="goodsList.length > 0">
              <li class="actLi" v-for="(item,index) in goodsList" :key="index" @click="goDetail(item)">
                <div class="van-clearfix flex box">
                  <img :src="baseImg + item.thumbnail" alt="" class="imgPic">
                  <div class="flexOne">
                    <div class="namePart">
                      <div class="proName">{{item.name}}</div>
                    </div>
                    <div class="desc"><span class="unit">￥</span>{{item.salesPrice}}</div>
                    <div class="sales">销量： {{item.salesVolume}}</div>
                  </div>

                </div>
              </li>
            </ul>
          </van-list>
        </van-pull-refresh>
      </div>
      <div v-else>
        <img src="@/assets/img/iv_error1@2x.png"
             class="noAct" />
        <div class="actText">暂无商品内容~~</div>
      </div>
    </div>
  </div>
</template>
<script>
import { removeParams, removeUser, getToken, setToken, setUid, setIsSystem, removeToken, getCode, getUid, removeCode, removeUid} from 'utils/auth'
import {throttle} from 'utils/index'
import { CODE_OK } from 'utils/publicData'
import EnvionmentVariables from '../../../../baseUrl'
export default {
  name: 'todayActivity',
  components: {
  },
  data () {
    return {
      active: 0,
      baseImg: EnvionmentVariables.IMAGE_HOST,
      goodsList: [],
      keyWord: '',
      tabAct: false,
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      timer: null, // 下拉刷新定时器、
      tabIndex: 0,
      scrollLeft: 0,
      pageIndex: 1, // 请求第几页
      pageSize: 6, // 每页请求的数量
      total: 0, // 总共的数据条数
      searchWord: '',
      k800:undefined
    }
  },
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background-color: #f8f8f8;');
  },
  created () {
    this.keyWord = this.$route.query.textWord;
    var token = this.$route.query.appToken;
    if (token) {
      setToken(token);
    }
    this.searchWord = this.keyWord;
    this.getGoodList();
  },
  mounted () {
    if (this.$route.query.k800) {
      this.k800 = this.$route.query.k800;
    }
  },
  methods: {
    inputFocus () {
      this.$router.go(-1);
    },
    closeWord () {
      this.searchWord = ""
    },
    goDetail (item) {
      this.$router.replace({ path:'/goodDetails', query: { id: item.id,k800:this.k800}});
    },
    goBack () {
      this.$router.replace({ path:'/search', query: {}});
    },
    searchInput: throttle(function () {
      this.pageIndex = 1;
      this.goodsList = [];
      this.getGoodList();
    }),
    // 获取商品列表
    getGoodList (article_type) {
      var that = this;
      var param = {
        service: "appagg",
        // service: "knowledge",
        query: {
          // agencyID: 56,
          // categoryId: 31,
          // searchKey: ""
          name: this.searchWord
        },
        pageIndex: that.pageIndex,
        pageSize: that.pageSize
      }
      this.$api.GetGoodsByPage(param).then(res => {
        if (res) {
          if (res.data.basis.status === 200) {
            that.total = res.data.rows;
            // 数据全部加载完成
            if (that.goodsList.length >= that.total) {
              that.upFinished = true; // 加载结束
            } else {
              that.goodsList = that.goodsList.concat(res.data.result);
            }
            if (res.data.result.length < that.pageSize) {
              that.upFinished = true;
            }
          }
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        console.log('finally')
        this.isDownLoading = false;
        this.isUpLoading = false;
      });
    },
    // 下拉刷新.
    onDownRefresh () {
      this.timer = setTimeout(() => {
        this.pageIndex = 1;
        this.goodsList = [];
        this.upFinished = false // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
        this.getGoodList(this.article_type); // 加载数据
        this.timer = null // 清空定时器
      }, 300)
    },
    // 上拉加载
    onLoadList () {
      this.pageIndex++;
      this.getGoodList(this.article_type);
    }
  }
}
</script>

<style scoped lang="less">
  .commonPadding{
    margin-top: 1.4rem;
  }
  .namePart{
    height: 90px;
  }
  .flex{
    display: flex;
  }
.close{
  width: 30px;
  height: 30px;
  position: absolute;
  right: 0.6rem;
  top:50%;
  transform: translateY(-50%);
}
.arrow{
  width: 40px;
  height: 40px;
  display: block;
  transform:rotate(180deg);
  -ms-transform:rotate(180deg); 	/* IE 9 */
  -moz-transform:rotate(180deg); 	/* Firefox */
  -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
  -o-transform:rotate(180deg); 	/* Opera */
}
.sales{
  font-size:26px;
  color: #B1B1B2;
  margin-top: 40px;
}
.desc{
  font-size:36px;
  color: #FF3E29;
  margin-top: 20px;
  font-weight: bold;
}
.unit{
  font-size:20px;
  color: #FF3E29;
  margin-top: 20px;
  font-weight: normal;
}
.proName{
  font-size: 30px;
  color: #1e2221;
  font-weight:bold;
  line-height: 40px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.imgPic{
  width: 230px;
  height: 230px;
  display: block;
  margin-right: 22px;
  border-radius: 10px;
}
  li.actLi {
    width: 100%;
    float: left;
    /*padding: 0px 20px;*/
    /*margin-top: 40px;*/
    box-sizing: border-box;
    color: #ffeca4;
    font-size: 24px;
    /*background: url("../../../assets/img/boxBg.png") no-repeat;*/
    /*background-size: 100%;*/
    /*height: 300px;*/
    padding: 0 12px;
    margin: 8px 0;
  }
  li.actLi > .box{
    background: #fff;
    border-radius: 12px;
  }
  .box {
    padding: 32px;
    box-sizing: border-box;
    width: 100%;
  }
.search_icon{
  width: 40px;
  height: 40px;
  //position: absolute;
  //left: 0.5rem;
  //top: 25px;
  z-index: 1000;
}
.s_input{
  padding: 0 0.3rem;
  position: relative;
}
.searchInput{
  border: 1px solid #d1d1d1;
  border-radius: 12px;
  background: rgba(208, 214, 230, 0.21);
  padding-top: 0;
  padding-bottom: 0;
  height: 64px;
  line-height: 64px;
}
.inputTop{
  height: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.2rem;
  background: #fff;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding-bottom: 0.2rem;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 100;
}
.flexOne{
  flex:1;
}
.carIcon{
  width: 1rem;
  height: 1rem;
  margin: auto;
  display: block;
}
.car{
  width: 1rem;
  height: 100%;
  position: relative;
}
.noAct{
  width: 356px;
  height: 282px;
  display: block;
  margin: 5rem auto 42px;
}
.actText{
  font-size: 33px;
  text-align: center;
  color: #3E3E3E;
}
.topNav{
  width: 100%;
  //position: fixed;
  box-sizing: border-box;
  height: 88px;
  line-height: 88px;
  top:0;
  z-index: 1000;
}
#tab{
  position: relative;
  height: 88px;
}
#appNav{
  width: 100%;
  height: 88px;
  overflow:hidden;
  position: absolute;
  left: 0;
  top: 0;
  background: #FFF1F0;
}
#appNav nav{
  padding: 0 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: middle;
  -ms-flex-align: middle;
  align-items: middle;
  overflow: auto;
}
#appNav p{
  text-align: center;
  font-size: 28px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  padding: 0px 50px;
  height: 100%;
  position: relative;
}
#appNav p.active{
  color: #E52317;
}
#appNav p.active::after{
  content: "";
  display: block;
  position: absolute;
  width: 45px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 4px;
  background: #E52317;
  border-radius: 2px;
}
#appNav p.active[data-v-1258668a] {
  color: #E52317;
}
.linePo {
  height: 26px;
  width: 100%;
  background: #f8f8f8;
}

</style>
